/**
 * Created by anatolij on 29.09.2026
 */

const RoyalLeagueLevelsAdapter = {
    SubscribeToEvents: function () {
        if (!cleverapps.config.features.includes("royal_league")) {
            return;
        }

        cleverapps.eventBus.on("outcome", (outcome) => {
            if (outcome !== GameBase.OUTCOME_VICTORY) {
                return;
            }

            const level = Game.currentGame.level;
            if (!level.isRegular() || level.isBonus()) {
                return;
            }

            const points = RoyalLeagueLevelsAdapter.calcVictoryPoints(level);
            cleverapps.personalBest.addPoint("royal_league", points);

            const mission = cleverapps.missionManager.findByType(Mission.TYPE_ROYAL_LEAGUE);
            if (!mission || !mission.isRunning() || mission.isCompleted()) {
                return;
            }

            mission.logic.earnPoints(points);
            RoyalLeagueLevelsAdapter.nextRound(mission);
        });

        cleverapps.missionManager.on("add", RoyalLeagueLevelsAdapter.onAddMission);
        cleverapps.missionManager.on("remove", RoyalLeagueLevelsAdapter.resetPlayButton);

        const mission = cleverapps.missionManager.findByType(Mission.TYPE_ROYAL_LEAGUE);
        if (mission) {
            RoyalLeagueLevelsAdapter.onAddMission(mission);
        }
    },

    onAddMission: function (mission) {
        if (mission.type !== Mission.TYPE_ROYAL_LEAGUE) {
            return;
        }

        let tier = mission.logic.getTier();
        mission.on("changed", () => {
            if (mission.logic.getTier() !== tier) {
                tier = mission.logic.getTier();
                RoyalLeagueLevelsAdapter.updatePlayButton(mission);
            }
        });
        RoyalLeagueLevelsAdapter.resetPlayButton(mission);
    },

    updatePlayButton: function (mission) {
        if (mission.type === Mission.TYPE_ROYAL_LEAGUE && cleverapps.playButton) {
            cleverapps.playButton.trigger("update");
        }
    },

    resetPlayButton: function (mission) {
        if (mission.type === Mission.TYPE_ROYAL_LEAGUE && cleverapps.playButton) {
            cleverapps.playButton.reset();
            cleverapps.playButton.trigger("update");
        }
    },

    calcVictoryPoints: function (level) {
        return RoyalLeagueLevelsAdapter.POINTS[level.getRewardTag()] || RoyalLeagueLevelsAdapter.POINTS.default;
    },

    getCurrentLevel: function (mission) {
        const round = RoyalLeagueLevelsAdapter.getRound(mission) + 1;
        const tag = round % RoyalLeagueLevelsAdapter.HARD_ROUND === 0 ? Level.TAGS.HARD : undefined;

        const level = cleverapps.user.getRandomLevel({ tag });
        level.setMissionTag(mission.getName().toLowerCase());
        return level;
    },

    getRound: function (mission) {
        return mission.details.round || 0;
    },

    nextRound: function (mission) {
        mission.details.round = RoyalLeagueLevelsAdapter.getRound(mission) + 1;
        mission.onChanged();
    },

    adjustMoves: function (moves) {
        return moves > RoyalLeagueLevelsAdapter.MIN_MOVES_TO_REDUCE ? moves - 1 : moves;
    }
};

RoyalLeagueLevelsAdapter.MIN_MOVES_TO_REDUCE = 10;
RoyalLeagueLevelsAdapter.HARD_ROUND = 5;

RoyalLeagueLevelsAdapter.POINTS = {
    default: 5,
    hard: 10
};

cleverapps.whenAllInitialized(() => RoyalLeagueLevelsAdapter.SubscribeToEvents());
